import { FilterDefinition } from "../../../context/FiltersProvider/types";

export type RootCauseCardType = "perimeter" | "baseline" | "comparison";
export type RootCauseCardAction = "period" | "criteria" | "filters" | "copy";

export interface RootCauseCardData {
	id: RootCauseCardType;
	availableActions: RootCauseCardAction[];
}

export type RootCauseMenuSection = {
	id: "saved" | "available" | "configurations";
	title: string;
	items: FilterDefinition[];
};

export const rootCauseCards: RootCauseCardData[] = [
	{
		id: "perimeter",
		availableActions: ["criteria"],
	},
	{
		id: "baseline",
		availableActions: ["period", "filters", "copy"],
	},
	{
		id: "comparison",
		availableActions: ["period", "filters", "copy"],
	},
];
